const alreadyWarned = new Set<string>();

/**
 * Development-only console warning, once per distinct message.
 *
 * Placeholders are filled on every render, and pre-fetched widgets render each
 * text up to three times for device variants, so an unguarded warning would
 * repeat for as long as the page is open. Silent in production: a wrong path is
 * a wiring mistake to catch while building, not noise on a customer's page.
 */
export function warnPlaceholderOnce(message: string): void {
  if (typeof process !== 'undefined' && process.env.NODE_ENV === 'production') {
    return;
  }
  if (alreadyWarned.has(message)) {
    return;
  }
  alreadyWarned.add(message);
  console.warn(message);
}
